import { render, staticRenderFns } from "./RoadBlockIcon.vue?vue&type=template&id=7dc74f1a&"
import script from "./RoadBlockIcon.vue?vue&type=script&lang=js&"
export * from "./RoadBlockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports